import { render, staticRenderFns } from "./activities-list.vue?vue&type=template&id=54dd02fe&scoped=true&"
import script from "./activities-list.vue?vue&type=script&lang=ts&"
export * from "./activities-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dd02fe",
  null
  
)

export default component.exports